export default "__VITE_ASSET__gd9oLKVo__"